export const SUPERUSER = 'superuser';
export const USERS_ADMIN = 'usersAdmin';

export const hasRole = ({roles = []}, role) => (roles ? roles.includes(role) || roles.includes(SUPERUSER) : false);
